import { useCallback, useEffect, useRef } from 'react';

const useOptionsList = (selected: string | undefined) => {
  const selectedRef = useRef<HTMLDivElement>(null);
  const handleScroll = useCallback(() => {
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [selected]);

  useEffect(() => {
    handleScroll();
  }, [handleScroll]);

  return { selectedRef };
};
export default useOptionsList;
